<template>
    <div class="analysisList-container">
        <headline ref="headline" :params="headLines" />
        <div class="content-container">
            <div class="filter-container">
                <div class="item" v-for="f in filters" :key="f.title">
                    <div class="left">
                        <span class="title">{{f.title}}</span>
                        <div :class="{conditions: true, expanded: f.expand}">
                            <p :class="{condition: true, on: c.selected}" v-for="c in f.list" :key="c.key" @click="selectCondition(c, f)">
                                {{c.title}}
                            </p>
                        </div>
                        <div class="expander" @click="changeExpand(f)" v-if="f.list.length > 10">
                            <img :src="f.expand ? icons.upward : icons.downward" alt="icon">
                        </div>
                    </div>
                </div>
                <div class="item" v-for="f in secondFilter" :key="f.title">
                    <div class="left">
                        <span class="title">{{f.title}}</span>
                        <div ref="secondList" :class="{conditions: true, expanded: showMore}">
                            <p :class="{condition: true, on: c.selected}" v-for="c in f.list" :key="c.key" @click="selectSecondCondition(c, f)">
                                {{c.title}}
                            </p>
                        </div>
                        <div class="expander" @click="showMore = !showMore" v-if="showCol">
                            <img :src="showMore ? icons.upward : icons.downward" alt="icon">
                        </div>
                    </div>
                </div>
                <!-- <div class="item" v-for="(f, d) in filters" :key="d">
                    <div class="left">
                        <span class="title">{{f.title}}</span>
                        <div :class="{conditions: true, expanded: f.expand}">
                            <p :class="{condition: true, on: c.selected}" v-for="(c, i) in f.list" :key="i" @click="selectCondition(c, f)">
                                {{c.title}}
                            </p>
                        </div>
                        <div class="expander" @click="changeExpand(f)" v-if="f.list.length > 10">
                            <img :src="f.expand ? icons.upward : icons.downward" alt="icon">
                        </div>
                    </div>
                </div> -->
                <div class="item">
                    <div class="left">
                        <span class="title">日期</span>
                        <div class="datePicker">
                            <date-picker v-model="datePicker" range placeholder="    开始时间    ～    结束时间" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" confirm>
                            </date-picker>
                        </div>
                    </div>
                </div>
                <!-- <analysisFilter :type="4" v-on:filterData="getFilters" /> -->
            </div>

            <div class="content">
                <div class="titleInfo">
                    <div class="left">
                        <div class="filterBtn">
                            <span @click="showFilter = !showFilter">{{orderListName}}</span>
                            <i @click="showFilter = !showFilter"></i>

                            <ul v-show="showFilter">
                                <li @click="sortChange(item)" :class="{on: item.selected}" v-for="item in orderList" :key="item.key">
                                    <span>{{item.val}}</span>
                                    <i></i>
                                </li>
                            </ul>
                        </div>
                        <p class="num">共<span>{{page.total}}</span>条数据</p>
                    </div>
                    <div class="right">
                        <div @click="reload" class="btn">
                            <i class="reload"></i>
                            <span>刷新</span>
                        </div>
                        <div @click="output" class="btn">
                            <i class="out"></i>
                            <span>导出</span>
                        </div>
                    </div>
                </div>

                <empty v-if="list.length == 0" :msg="'暂无内容传播力分析数据'"></empty>

                <div v-if="list.length > 0" class="listTitle">
                    <p class="l">稿件标题</p>
                    <p class="s">平台类型</p>
                    <p class="m">发布媒体</p>
                    <p class="s">报刊</p>
                    <p class="s">网站</p>
                    <p class="s">微信</p>
                    <p class="s">APP</p>
                    <p class="s">微博</p>
                    <p class="s">头条</p>
                    <p class="s">总转载量</p>
                    <p class="last">传播力指数</p>
                </div>

                <div v-if="list.length > 0" class="listContent">
                    <ul>
                        <li @click="toDetail(item.id)" v-for="item in list" :key="item.id">
                            <div>
                                <p class="l">{{item.title}}</p>
                                <p class="s">{{item.type}}</p>
                                <p class="m">{{item.client_name}}</p>
                                <p class="s">{{item.szb}}</p>
                                <p class="s">{{item.web}}</p>
                                <p class="s">{{item.weixin}}</p>
                                <p class="s">{{item.app}}</p>
                                <p class="s">{{item.weibo}}</p>
                                <p class="s">{{item.toutiao}}</p>
                                <p class="s">{{item.total}}</p>
                                <p :title="item.trans_power" class="last">{{item.trans_power}}</p>
                            </div>
                        </li>
                    </ul>
                </div>

                <pages :page_count="page.pageCount" :index="page.pageIndex" :total="page.total" />
            </div>
        </div>
    </div>
</template>

<script>
import pages from '@components/pages'
import DatePicker from 'vue2-datepicker'
import common from '@common/common'
import { apis } from '@common/config'
import headline from "@components/headline";
import empty from '@components/empty'
import analysisFilter from '@components/analysisFilter'

export default {
    components: {
        pages, DatePicker, empty, headline, analysisFilter
    },
    watch: {
    datePicker: {
        deep: true,
            handler: function (n) {
                // this.page.pageIndex = 1;

                this.start = common.stampToTime(n[0]);
                this.end = common.stampToTime(n[1]);
                let time = {
                    start: this.start,
                    end: this.end
                }
                this.getFilters(time)
                // this.changeTime();
            }
        }
    },
    data() {
        return {
            list: [],
            orderListName: '',
            showTime: false,
            showMore: false,
            showCol: false,
            client_id: '',
            orderList: [],
            secondFilter: [],
            filterOptions: {},
            searchOptions: {},
            showFilter: false,
            headLines: {
                title: "",
                showLink: false,
                filter: false
            },
            page: {
                pageCount: 0,
                pageIndex: 1,
                pageSize: 10,
                total: 0
            },
            start: '',
            end: '',
            datePicker: '',
            filters: [],
            icons: {
                up: require('@assets/img/topics/up.svg'),
                down: require('@assets/img/topics/down.svg'),
                downward: require('@assets/img/common/xiala.svg'),
                upward: require('@assets/img/common/upward.svg')
            }
        }
    },
    methods: {
        changeExpand(c, key) {
            // 切换类目展开／收起
            this.$set(c, 'expand', !c.expand)

            // this.$nextTick(() => {
            //     if (!c.expand) {
            //     this.$refs[key][0].scrollTop = 0
            //     }
            // })
        },
        toDetail(id) {
            common.jump('/analysisDetail?d='+id, true)
        },
        reload() {
            this.page.pageIndex = 1;
            this.getList()
        },
        selectCondition(c, f) {
            this.filters[0].list.forEach(item => {
                item.selected = false
            })
            c.selected = true
            this.showMore = false
            if(c.title != '全部'){
                let arr = []
                arr.push(c)
                if(arr.length > 0){
                    if(arr[0].list.length > 0){
                        arr[0].list[0].selected = true
                    }
                }
                this.secondFilter = arr
                // console.log(this.secondFilter)
                this.$nextTick(() => {
                    let maxWidth = this.$refs.secondList[0].getBoundingClientRect().width
                    let secondListDom = this.$refs.secondList[0]
                    let secondListPDom = secondListDom.getElementsByTagName('p')
                    let length = 0
                    for (let index = 0; index < secondListPDom.length; index++) {
                        const element = secondListPDom[index];
                        length += element.getBoundingClientRect().width
                    }

                    if(length > maxWidth){
                        this.showCol = true
                    }else{
                        this.showCol = false
                    }
                })
                let data = {
                    platform_id: c.key,
                    client_id: ''
                }
                this.getFilters(data)
            }else{
                this.secondFilter = []
                let data = {
                    platform_id: '',
                    client_id: ''
                }
                this.getFilters(data)
            }
        },
        selectSecondCondition(c, f) {
            this.secondFilter[0].list.forEach(item => {
                item.selected = false
            })
            c.selected = true
            let data = {
                client_id: c.key
            }
            this.getFilters(data)
        },
        getFilters(data) {
            // 获取过滤条件数据
            // this.filterOptions = data
            this.filterOptions = Object.assign({}, this.filterOptions, data)
            this.page.pageIndex = 1
            this.getList()
        },
        getList() {
            let info = {
                page: this.page.pageIndex,
                pagesize: this.page.pageSize,
            }

            Object.assign(info, this.searchOptions, this.filterOptions)

            common.myFetch(apis.analysissearch, info).then(res => {
                if(res) {
                    // console.log(res)
                    let datePicker = []
                    this.list = res.list
                    res.params.list_search.forEach(item => {
                        if(item.key == 'client_id'){
                            let filters = []
                            filters.push(item)
                            this.filters = filters
                        }else if(item.key == 'start' || item.key == 'end'){
                            if(item.key == 'start'){
                                datePicker[0] = item.val
                            }else{
                                datePicker[1] = item.val
                            }
                            this.showTime = true
                        }else if(item.key == 'orderBy'){
                            this.orderList = item.list
                            item.list.forEach(items => {
                                if(items.selected){
                                    this.orderListName = items.val
                                }
                            })
                        }
                    })
                    this.generateSearchs(res.params.top_search.option.list)
                    this.$set(this.page, 'pageCount', common.calculatePage(res.page.row_count - 0, this.page.pageSize))
                    this.$set(this.page, 'total', res.page.row_count - 0)
                    this.datePicker = datePicker
                }
            })
        },
        generateSearchs(data) {
            // 整理搜索栏数据
            const types = data.map((i) => {
                return {
                name: i.title,
                code: i.key,
                selected: i.selected
                }
            })

            const filterData = {
                types: types,
                callback: (o) => {
                    this.getSearch(o)
                }
            }
            this.postSearch(filterData)
        },
        getSearch(d) {
            // 接收搜索框数据
            this.searchOptions = d
            this.page.pageIndex = 1
            this.getList()
        },
        postSearch(data) {
            // 发送搜索框数据
            this.$refs.headline.passFilterData(data)
            // this.$emit('filterData', data)
        },
        sortChange(item) {
            this.orderListName = item.val;
            this.showFilter = false;
            let data = {
                orderBy: item.key
            }
            this.getFilters(data)
        },
        //导出数据
        output (){
            let info = {
                
            }

            const userKeys = common.userKeys();
            const params = Object.assign(info, this.searchOptions, this.filterOptions, userKeys)
            // const params = Object.assign({}, info, userKeys);
            const url = apis.searchexport;

            common.exportRes(url, params)
        }
    },
    created() {
        this.headLines.title = '内容传播力分析'
        this.getList()
    }
}
</script>

<style lang="less" scoped>
    @import '../../assets/css/global.less';
    .analysisList-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 100%;

        .datePicker {
            width: 320px;
            height: 30px;
            border-radius: 4px;
            // border: 1px solid #DCDCDC;
            box-sizing: border-box;
        }

        .content-container {
            display: flex;
            flex-direction: column;
            width: 100%;
            // height: calc(100vh - 70px);
            padding: 30px 67px 50px;
            box-sizing: border-box;

            .filter-container {
                width: 100%;
                background: #F9F9F9;
                box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                border-radius: 4px;
                padding: 20px 30px;
                box-sizing: border-box;

                .item {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 20px;
                    .left {
                        display: flex;
                        align-items: flex-start;
                        // overflow: hidden;
                        .title {
                        width: 74px;
                        height: 30px;
                        line-height: 30px;
                        font-size: 13px;
                        // color: @sub;
                        color: @green;
                        text-align-last: justify;
                        margin-right: 30px;
                        font-weight: bold;
                        }
                        .expander {
                        width: 30px;
                        height: 30px;
                        border: 1px solid @dc;
                        border-radius: 2px;
                        margin-left: 10px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;
                        }
                        .conditions {
                        height: 38px;
                        overflow: hidden;
                        flex: 1;
                        flex-wrap: wrap;
                        display: flex;
                        align-items: center;
                        &::-webkit-scrollbar {
                            width: 6px;
                        }
                        &::-webkit-scrollbar-thumb {
                            background: #ddd;
                            border-radius: 2px;
                        }
                        }
                        .expanded {
                        height: auto;
                        // overflow-y: auto;
                        }
                        .condition {
                        padding: 0 8px;
                        min-width: 80px;
                        word-break: keep-all;
                        height: 30px;
                        text-align: center;
                        line-height: 30px;
                        font-size: 14px;
                        border: 1px solid transparent;
                        border-radius: 100px;
                        color: @sub;
                        margin: 0 4px 10px 0;
                        cursor: pointer;
                        }
                        .condition:last-child {
                        margin-right: 0;
                        }
                        .on {
                        color: @green;
                        border-color: @green;
                        }
                    }
                    .create {
                        width: 120px;
                        height: 40px;
                        border-radius: 100px;
                        background-color: @green;
                        color: #fff;
                        font-size: 14px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        &:hover {
                        .btnHover;
                        }
                        &:active {
                        .btnActive;
                        }
                        .icon {
                        margin-right: 10px;
                        }
                    }
                }
            }

            .content {
                display: flex;
                flex-direction: column;
                width: 100%;
                flex: 1;
                background: #F9F9F9;
                box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                border-radius: 4px;
                margin-top: 30px;
                padding-bottom: 50px;
                box-sizing: border-box;

                .titleInfo {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                    padding: 25px 30px;
                    box-sizing: border-box;

                    .left {
                        display: flex;
                        flex-direction: row;
                        align-items: center;

                        .filterBtn {
                            position: relative;
                            display: flex;
                            flex-direction: row;
                            justify-content: center;
                            align-items: center;
                            // min-width: 135px;
                            height: 30px;
                            padding: 0 17px;
                            line-height: 30px;
                            text-align: center;
                            border-radius: 4px;
                            border: 1px solid #DCDCDC;
                            box-sizing: border-box;
                            cursor: pointer;
                            margin-right: 20px;

                            & > span {
                                font-size: 14px;
                                line-height: 20px;
                                color: #41B48C;
                                font-weight: bold;
                            }

                            & > i {
                                display: block;
                                width: 8px;
                                height: 12px;
                                background: url('../../assets/img/analysis/up.png') no-repeat;
                                background-position:  center center;
                                background-size: 100% 100%;
                                margin-left: 10px;
                            }

                            ul {
                                position: absolute;
                                top: 40px;
                                left: 0;
                                width: 200px;
                                background: #fff;
                                border-radius: 4px;
                                overflow: hidden;

                                li {
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                    align-items: center;
                                    width: 100%;
                                    line-height: 30px;
                                    font-size: 14px;
                                    padding: 5px 10px;
                                    box-sizing: border-box;

                                    &:hover {
                                        background: rgba(65, 180, 140, 0.15);
                                    }

                                    &.on {
                                        i {
                                            display: block;
                                            width: 14px;
                                            height: 11px;
                                            background: url('../../assets/img/common/select.svg') no-repeat;
                                            background-position: center center;
                                            background-size: 100% 100%;
                                        }
                                    }
                                }
                            }
                        }

                        .num {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            font-size: 14px;
                            color: #829191;
                            font-weight: 500;

                            span {
                                color: #050F0F;
                                font-weight: bold;
                            }
                        }
                    }

                    .right {
                        display: flex;
                        flex-direction: row;
                        align-items: center;

                        .btn {
                            display: flex;
                            flex-direction: row;
                            justify-content: center;
                            align-items: center;
                            border-radius: 20px;
                            width: 120px;
                            height: 40px;
                            border: 1px solid #41B48C;
                            box-sizing: border-box;
                            user-select: none;
                            cursor: pointer;

                            i {
                                display: flex;
                                width: 18px;
                                height: 18px;
                                background: url('../../assets/img/analysis/reload.png') no-repeat;
                                background-position:  center center;
                                background-size: 100% 100%;
                                margin-right: 10px;
                            }

                            span {
                                font-size: 14px;
                                line-height: 20px;
                                color: #41B48C;
                            }

                            &:nth-last-of-type(1) {
                                background: #41B48C;
                                border-radius: 20px;
                                margin-left: 10px;

                                i {
                                    display: flex;
                                    width: 18px;
                                    height: 18px;
                                    background: url('../../assets/img/analysis/esc.png') no-repeat;
                                    background-position:  center center;
                                    background-size: 100% 100%;
                                }

                                span {
                                    font-size: 14px;
                                    line-height: 20px;
                                    color: #FFF;
                                }
                            }
                        }
                    }
                }

                .listTitle {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    width: 100%;
                    height: 40px;
                    background: #F9F9F9;
                    padding: 0 30px;
                    box-shadow: 0px 0px 10px 0px rgba(6, 21, 50, 0.05);
                    box-sizing: border-box;
                    font-size: 14px;
                    color: #829191;
                    font-weight: 500;

                    .l {
                        flex: 1;
                    }

                    .m {
                        width: 10%;
                        text-align: center;
                    }

                    .s {
                        width: 8%;
                        text-align: center;
                    }

                    .last {
                        width: 70px;
                        text-align: center;
                        margin-left: 30px;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;
                    }
                }

                .listContent {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    width: 100%;
                    background: #F9F9F9;
                    box-sizing: border-box;
                    font-size: 14px;
                    color: #050F0F;
                    font-weight: 500;
                    margin-top: 10px;

                    ul {
                        display: flex;
                        flex-direction: column;
                        width: 100%;

                        li {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            width: 100%;
                            height: 70px;
                            padding: 0 30px;
                            // border-bottom: 1px solid #F0F0F0;
                            box-sizing: border-box;

                            div {
                               display: flex;
                                flex-direction: row;
                                align-items: center;
                                width: 100%;
                                height: 70px; 
                                border-bottom: 1px solid #F0F0F0;
                                box-sizing: border-box;
                            }

                            &:hover {
                                background: rgba(185, 195, 195, 0.15);
                                .l {
                                    color: #41B48C;
                                }
                            }

                            p {
                                font-size: 14px;
                                color: #050F0F;
                            }
                        }
                    }

                    .l {
                        flex: 1;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                    }

                    .m {
                        width: 10%;
                        text-align: center;
                    }

                    .s {
                        width: 8%;
                        text-align: center;
                    }

                    .last {
                        width: 70px;
                        text-align: center;
                        margin-left: 30px;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;
                    }
                }
            }
        }
    }
</style>